import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SimpleForm from "@/components/SimpleForm.vue";
import { ref } from "vue";
import type { FormInstance } from "element-plus";
import UserService, { CreateLeadSpec } from "../../services/UserService";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeadCreateModal',
  emits: ["create-success"],
  setup(__props, { expose: __expose, emit: emits }) {


const modalRef = ref();
const isLoading = ref(false);
const ruleFormRef = ref<FormInstance>();

const ruleForm = ref<CreateLeadSpec>({
  name: "",
  email: "",
  phoneNumber: "",
});

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      isLoading.value = true;
      await UserService.createLead(ruleForm.value);
      MsgPrompt.success("Create lead success").then(() => {
        isLoading.value = false;
        emits("create-success");
        hide();
      });
    } else {
      MsgPrompt.error("Error submit!!!");
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
};

const rules = ref<any>({
  name: [
    { required: true, message: "Please input user name", trigger: "blur" },
  ],
  email: [
    { required: true, message: "Please input email address", trigger: "blur" },
    {
      type: "email",
      message: "Please input correct email address",
      trigger: "blur",
    },
  ],
  phoneNumber: [
    { required: true, message: "Please input phone number", trigger: "blur" },
  ],
});

const show = () => {
  modalRef.value?.show();
  resetForm(ruleFormRef.value);
};

const hide = () => {
  modalRef.value?.hide();
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.createLead'),
    "is-loading": isLoading.value,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm.value,
        rules: rules.value,
        "label-width": "120px",
        class: "demo-ruleForm",
        size: "default",
        "status-icon": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.userName'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: ruleForm.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.value.name) = $event)),
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.email'),
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: ruleForm.value.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.value.email) = $event)),
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.phoneNum'),
            prop: "phoneNumber"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: ruleForm.value.phoneNumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.value.phoneNumber) = $event)),
                disabled: isLoading.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "warning",
                plain: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm(ruleFormRef.value))),
                loading: isLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (resetForm(ruleFormRef.value))),
                disabled: isLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})